import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03ac8878&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ac8878')) {
      api.createRecord('03ac8878', component.options)
    } else {
      api.reload('03ac8878', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03ac8878&", function () {
      api.rerender('03ac8878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Bed/index.vue"
export default component.exports